import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { TreeFieldParams } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TreeField' },
  __name: 'Tree',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {



const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, "Компонента находится в разработке!"))
}
}

})